// import { auth } from "@/common/firebase.js";
import apiCall from "@/api";
import { LOGIN, USER } from "@/api/endpoints";
import { auth } from "@/common/firebase.js";

export default {
  namespaced: true,
  state: {
    loadingState: false,
    user: false,
    firebaseUser: false,
    AvailableAssessments: false
  },
  getters: {
    GET_LOGIN_LOADING_STATE(state) {
      return state.loadingState;
    },
    GET_USER(state) {
      return state.user;
    },
    GET_FIREBASE_USER(state) {
      return state.firebaseUser;
    },
    GET_AVAILABLE_ASSESSMENT(state) {
      return state.AvailableAssessments;
    },
    IS_ADMIN(state) {
      return typeof state.user.roles != 'undefined' && state.user.roles.includes('administrator');
    },
  },
  mutations: {
    LOGIN_LOADING(state, loadingState) {
      state.loadingState = loadingState;
    },
    SET_USER(state, payload) {
      if (payload) {
        state.user = {
          uid: payload.data.ID,
          display_name: payload.data.display_name,
          email: payload.data.user_email,
          roles: payload.roles
        };
      } else {
        state.user = payload;
      }
    },
    SET_FIREBASE_USER(state, payload) {
      if (payload) {
        state.firebaseUser = {
          uid: payload.uid,
          display_name: payload.name,
          email: payload.email
        };
      } else {
        state.firebaseUser = payload;
      }
    },
    SET_AVAILABLE_ASSESSMENT(state, payload) {
      if (payload) {
        state.AvailableAssessments = payload.assessments;
      }
    }
  },
  actions: {
    LOGOUT(context) {
      localStorage.removeItem("user-token");
      context.commit("SET_USER", false);
    },
    USER_REQUEST(context) {
      context.commit("MESSAGE", "Hello USR");
      return apiCall
        .get(USER)
        .then(response => {
          // handle success
          if (response.data.success) {
            context.commit("SET_USER", response.data.data);
            context.commit("SET_AVAILABLE_ASSESSMENT", response.data.data.data);
            return true;
          } else {
            context.dispatch("LOGOUT");
            return false;
          }
        })
        .catch(function() {
          context.dispatch("LOGOUT");
          return false;
        })
    },
    FIREBASE_LOGIN(context, { email, password }) {
      context.commit("LOGIN_LOADING", true);
      return fetch(
        "https://europe-west1-oneandall-dev-9513d.cloudfunctions.net/checkUserExists",
        {
          method: "POST",
          cache: "no-cache",
          mode: "cors",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ email: email, password: password })
        }
      ).then(res => {
        if (res.ok) {
          return auth
            .signInWithEmailAndPassword(email, password)
            .then(() => {
              context.commit("LOGIN_LOADING", false);
              return true;
            })
            .catch(() => {
              context.commit("LOGIN_LOADING", false);
              return false;
            });
        }

        context.commit("LOGIN_LOADING", false);
        return false;
      });
    },
    LOGIN(context, { email, password }) {
      context.commit("LOGIN_LOADING", true);
    
      return apiCall
        .post(LOGIN, { username: email, password: password })
        .then(async response => {
          context.commit("LOGIN_LOADING", false);
          // handle success
          
          if (response.data.token) {
            localStorage.setItem("user-token", response.data.token);
            await context.dispatch("USER_REQUEST", response.data);
            return true;
            //commit("AUTH_SUCCESS", response.data.data);
            // await dispatch("USER_REQUEST");
            //resolve(response);
          } else {
            context.commit("AUTH_ERROR");
            localStorage.removeItem("user-token");
            //reject(response);
            return false;
          }
        })
        .catch(function() {
          context.commit("LOGIN_LOADING", false);
          // handle error
          //commit("AUTH_ERROR");
          //commit("LOGIN_LOADING", false);
          localStorage.removeItem("user-token");
          // reject(error);
          return false;
        })

      // return fetch(
      //   "https://europe-west1-oneandall-dev-9513d.cloudfunctions.net/checkUserExists",
      //   {
      //     method: "POST",
      //     cache: "no-cache",
      //     mode: "cors",
      //     credentials: "same-origin",
      //     headers: {
      //       "Content-Type": "application/json"
      //     },
      //     body: JSON.stringify({ email: email, password: password })
      //   }
      // ).then(res => {
      //   if (res.ok) {
      //     return auth
      //       .signInWithEmailAndPassword(email, password)
      //       .then(() => {
      //         context.commit("LOGIN_LOADING", false);
      //         return true;
      //       })
      //       .catch(() => {
      //         context.commit("LOGIN_LOADING", false);
      //         return false;
      //       });
      //   }

      //   context.commit("LOGIN_LOADING", false);
      //   return false;
      // });
    }
  }
};
